export const workerUseYnType = {
    // 정상
    OK: 'OK',
    // 정지
    STOP: 'STOP',
    // 퇴직
    LEAVE: 'LEAVE',
};
